import React from "react";
import { createBrowserRouter } from "react-router-dom";
import Landing from "./client/landing/landing";
import AproposCentre from "./client/aproposCentre/aproposCentre";
import NousContacter from "./client/nousContacter/nousContacter";
import DemandeSalle from "./client/reservationSalle/demandeSalle";
import EtatDemandeLogin from "./client/reservationSalle/etatDemandeLogin";
import EtatDemande from "./client/reservationSalle/etatDemande";
import ConfirmationPresence from "./client/reservationSalle/confirmationPresence";
import Login from "./admin/login";
import Dashboard from "./admin/dashboard/dashboard";
import Reservations from "./admin/reservations/reservations";
import Messages from "./admin/messages/messages";
import Configurations from "./admin/configurations/configurations";
import Calendrier from "./admin/calendrier/calendrier";
import WorldcupDetails from "./client/landing/components/actualites/firstworldcup/worldcupDetails";
import Soumission from "./client/landing/components/actualites/firstworldcup/soumission";
import ReservationSalle from "./client/reservationSalle/reservationSalle";
import Inscription from "./client/landing/components/actualites/firstworldcup/inscription";
import Event from "./admin/event/event";
import InscriptionStudent from "./client/landing/components/actualites/firstworldcup/inscriptionStudent";
import InscriptionAtelier from "./client/landing/components/actualites/firstworldcup/inscriptionAtelier";

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Landing  activeItem='Accueil' />
  },
  {
    path: '/apropos-centre',
    element: <AproposCentre activeItem='A propos du centre' />
  },
  {
    path: '/demande-salle',
    element: <DemandeSalle activeItem='Demande de salle' />
  },
  {
    path: '/suivre-demande-login',
    element: <EtatDemandeLogin />
  },
  {
    path: '/suivre-demande',
    element: <EtatDemande />
  },
  {
    path: '/confirmation-presence',
    element: <ConfirmationPresence />
  },
  {
    path: '/nous-contacter',
    element: <NousContacter activeItem='Nous contacter' />
  },
  {
    path: '/worldcup-firstEdition',
    element: <WorldcupDetails />
  },
  {
    path: '/worldcup-soumission',
    element: <Soumission />
  },
  {
    path: '/worldcup-inscription',
    element: <Inscription />
  },
  {
    path: '/worldcup-inscription-student',
    element: <InscriptionStudent />
  },
  {
    path: '/reservation',
    element: <ReservationSalle />
  },
  {
    path: '/inscriptionAtelierResident',
    element: <InscriptionAtelier typeInscrit='résidents' />
  },
  {
    path: '/inscriptionAtelierEtudiant',
    element: <InscriptionAtelier typeInscrit='étudiants' />
  },
  {
    path: '/inscriptionAtelierSpecialiste',
    element: <InscriptionAtelier typeInscrit='spécialistes' />
  },

  // ---------------------admin----------------------------------------
  {
    path: '/admin',
    element: <Login />
  },
  {
    path: '/dashboard',
    element: <Dashboard />
  },
  {
    path: '/reservations',
    element: <Reservations />
  },
  {
    path: '/messages',
    element: <Messages />
  },
  {
    path: '/configurations',
    element: <Configurations />
  },
  {
    path: '/calendrier',
    element: <Calendrier />
  },
  {
    path: '/event',
    element: <Event />
  },

]);
